<template>
    
    <div class="">
        <!-- Summary -->
        <div class="row">
            <div class="col-md-6">
                <div class="input-group flex-nowrap p-1 border-0 border-end" :class="[light.border]" style="cursor: default;">
                    <div class="btn me-1" :class=[light.text,light.border,light.back] style="align-items: center; display:flex; width: 20%">
                        <i class="fa-solid text-primary fa-location-dot me-2" style="font-size: 25px;"></i>
                        <div class="w-100 text-start fw-light fs-4">
                            Sites
                        </div>
                    </div>
                    <div class="btn me-1" :class=[light.text,light.border,light.back] title="Connected sites." style="width: 20%;">
                        <div class="fa-solid fa-circle-check text-success" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.sites.connected}}
                        </div>
                    </div>
                    <div class="btn me-1" :class=[light.text,light.border,light.back] title="Disconnected sites." style="width: 20%;">
                        <div class="fa-solid fa-circle-xmark text-danger" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.sites.disconnected}}
                        </div>
                    </div>
                    <div class="btn me-1" :class=[light.text,light.border,light.back] title="Disabled sites." style="width: 20%;">
                        <div class="fa-solid fa-ban" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.sites.disabled}}
                        </div>
                    </div>
                    <div class="btn fs-6" :class=[light.text,light.border,light.back] title="Total sites." style="width: 20%;">
                        <div class="fa-solid fa-t" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.sites.total}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="input-group flex-nowrap p-1 border-0 border-start" :class="[light.border]" style="cursor: default;">
                    <div class="btn me-1" :class=[light.text,light.border,light.back] style="align-items: center; display:flex; width: 25%">
                        <i class="fa-solid text-primary fa-server me-2" style="font-size: 25px;"></i>
                        <div class="w-100 text-start fw-light fs-4">
                            Devices
                        </div>
                    </div>
                    <div class="btn me-1" :class="[light.text, light.back, light.border]" title="Connected devices." style="width: 25%;">
                        <div class="fa-solid text-success fa-circle-check" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.devices.connected}}
                        </div>
                    </div>
                    <div class="btn me-1" :class="[light.text, light.back, light.border]" title="Disconnected devices." style="width: 25%;">
                        <div class="fa-solid text-danger fa-circle-xmark" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.devices.disconnected}}
                        </div>
                    </div>
                    <div class="btn" :class=[light.text,light.border,light.back] title="Total devices." style="width: 25%;">
                        <div class="fa-solid fa-t" style="font-size: 20px;"></div>
                        <div class="w-100">
                            {{maindata.summary.devices.total}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Connected & Disconnected Sites. -->
        <div class="row mt-3">
            <div class="col-md-6">
                <div class="input-group flex-nowrap mb-1">    
                    <div class="text-start mt-1 fs-5 fw-light me-1" :class="[light.text]" style="letter-spacing: 3px; width: 45%;">
                        <i class="fa-solid fa-circle-check text-success"></i>
                        Connected Sites ({{connected_elements.length}})
                    </div>
                    <div style="width: 55%;">
                        <input type="text" class="btn fs-6 me-1" :class="[light.text,light.header, light.border]" v-model="connected_searchword" placeholder="Search" style="width:50%; height: 35px; cursor: text;">
                        <select class="btn fs-6" :class="[light.text,light.header, light.border]" v-model="connected_searchfield" style="width: 48%; height: 35px;">
                            <option :value="null">Select an option...</option>
                            <option value="sitename">By Site Name</option>
                            <option value="alias">By Country</option>
                            <option value="popname">By Pop Name</option>
                        </select>
                    </div>
                </div>
                <div class="rounded" style="height: 520px;">
                    <div>
                        <div class="input-group flex-nowrap" style="overflow-y:scroll;" :class="[light.border,light.header]">
                            <div class="btn text-start text-primary" style="width: 20%; font-size: 15px;" title="Country name.">
                                <i class="fa-solid fa-globe"></i>
                            </div>
                            <div class="btn text-start" :class="[light.text,light.header]" style="width: 30%; font-size: 15px;" title="Site name.">
                                <i class="fa-solid fa-id-badge" ></i>
                            </div>
                            <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Pop name.">
                                <i class="fa-solid fa-object-group"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 5%; font-size: 15px;" title="Operational Status">
                                <i class="fa-solid fa-heart-pulse"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 5%; font-size: 15px;" title="Connectivity Status">
                                <i class="fa-solid fa-signal"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Last Connection">
                                <i class="fa-solid fa-calendar-day"></i>
                            </div>
                        </div>
                    </div>
                    <div :class="[light.border]" style="overflow-y:scroll; height: 473px;">
                        <div class="input-group flex-nowrap" :class="[light.border_bottom]" v-for="(ds, is) in connected_elements" :key="is">
                            <div class="btn fw-bold text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Country name.">
                                {{ds.alias}}
                            </div>
                            <div class="btn fw-bold text-start" :class="[light.text]" style="width: 30%; font-size: 11px; word-wrap: break-word;" title="Site name.">
                                {{ds.sitename}}
                            </div>
                            <div class="btn fw-bold text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Pop name.">
                                {{ds.popname ? ds.popname:'-'}}
                            </div>
                            <div class="btn" :class="[light.text]" style="width: 5%; font-size: 20px;" title="Operational Status">
                                <i class="fa-solid" :class="{'fa-circle-check text-success': ds.operational, 'fa-circle-xmark text-danger': !ds.operational}"></i>
                            </div>
                            <div class="btn" :class="[light.text]" style="width: 5%; font-size: 20px;" title="Connectivity Status">
                                <i class="fa-solid" :class="{'fa-circle-check text-success': ds.connectivity, 'fa-circle-xmark': !ds.connectivity}"></i>
                            </div>
                            <div class="btn" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Disabled sites.">
                                {{ds.timestamp}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="input-group flex-nowrap mb-1">
                    <div class="text-start mt-1 fs-5 fw-light" :class="[light.text]" style="letter-spacing: 3px; width: 45%;">
                        <i class="fa-solid fa-circle-xmark text-danger"></i>
                        Disconnected Sites ({{disconnected_elements.length}})
                    </div>
                    <div style="width: 55%;">
                        <input type="text" class="btn fs-6 me-1" :class="[light.text,light.header, light.border]" v-model="disconnected_searchword" placeholder="Search" style="width:50%; height: 35px; cursor: text;">
                        <select class="btn fs-6" :class="[light.text,light.header, light.border]" v-model="disconnected_searchfield" style="width: 48%; height: 35px;">
                            <option :value="null">Select an option...</option>
                            <option value="sitename">By Site Name</option>
                            <option value="alias">By Country</option>
                            <option value="popname">By Pop Name</option>
                        </select>
                    </div>
                </div>
                <div class="rounded" style="height: 520px;">
                    <div>
                        <div class="input-group flex-nowrap" style="overflow-y:scroll;" :class="[light.border,light.header]">
                            <div class="btn text-start text-primary" style="width: 20%; font-size: 15px;" title="Country name.">
                                <i class="fa-solid fa-globe"></i>
                            </div>
                            <div class="btn text-start" :class="[light.text,light.header]" style="width: 30%; font-size: 15px;" title="Site name.">
                                <i class="fa-solid fa-id-badge" ></i>
                            </div>
                            <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Pop name.">
                                <i class="fa-solid fa-object-group"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 5%; font-size: 15px;" title="Operational Status">
                                <i class="fa-solid fa-heart-pulse"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 5%; font-size: 15px;" title="Connectivity Status">
                                <i class="fa-solid fa-signal"></i>
                            </div>
                            <div class="btn" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Last Connection">
                                <i class="fa-solid fa-calendar-day"></i>
                            </div>
                        </div>
                    </div>
                    <div :class="[light.border]" style="overflow-y:scroll; height: 473px;">
                        <div class="input-group flex-nowrap" :class="[light.border_bottom]" v-for="(ds, is) in disconnected_elements" :key="is">
                            <div class="btn fw-bold text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Country name.">
                                {{ds.alias}}
                            </div>
                            <div class="btn fw-bold text-start" :class="[light.text]" style="width: 30%; font-size: 11px; word-wrap: break-word;" title="Site name.">
                                {{ds.sitename}}
                            </div>
                            <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 11px;" title="Pop name.">
                                {{ds.popname ? ds.popname:'-'}}
                            </div>
                            <div class="btn"  style="width: 5%; font-size: 20px;" title="Operational Status">
                                <i class="fa-solid" :class="{'fa-circle-check text-success': ds.operational, 'fa-circle-xmark text-danger': !ds.operational}"></i>
                            </div>
                            <div class="btn" style="width: 5%; font-size: 20px;" title="Connectivity Status">
                                <i class="fa-solid" :class="{'fa-circle-check text-success': ds.connectivity, 'fa-circle-xmark text-danger': !ds.connectivity}"></i>
                            </div>
                            <div class="btn" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Disabled sites.">
                                {{ds.timestamp}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Internet Services. -->
        <div class="row mt-4">
            <div class="col-md-4">
                <div class="text-start fs-4 fw-light" :class="[light.text]" style="letter-spacing: 3px;">
                    <i class="fa-solid text-primary fa-earth-americas"></i>
                    Internet Services
                </div>
            </div>
            <div class="col-md-3"></div>
            <div class="col-md-5">
                <div class="text-end fs-6 fw-light mt-2" :class="[light.text]" style="align-content: center;">
                    <i class="fa-solid text-warning fa-circle-info"></i>
                    An Internet service is considered degraded when it doesn't have a tunnel.
                </div>
            </div>
        </div>
        <div class="row mt-1">
            <div class="col-md-4">
                <!-- Summary -->
                <div class="input-group flex-nowrap rounded">
                    <div class="btn me-1" :class="[light.back, light.border]" title="Connected Services" style="width: 34%">
                        <i class="fa-solid fa-circle-check text-success" style="font-size: 23px;"></i>
                        <div :class="[light.text]">{{maindata.internet.summary.connected}}</div>
                    </div>
                    <div class="btn" :class="[light.back,light.border]" title="Disconnected Services" style="width: 34%">
                        <i class="fa-solid fa-circle-xmark text-danger" style="font-size: 23px;"></i>
                        <div :class="[light.text]">{{maindata.internet.summary.disconnected}}</div>
                    </div>
                    <div class="btn ms-1" :class="[light.back,light.border]" title="Total Services" style="width: 34%">
                        <i class="fa-solid fa-t" :class="[light.text]" style="font-size: 23px;"></i>
                        <div :class="[light.text]">{{maindata.internet.summary.total}}</div>
                    </div>
                </div>
                <!-- Bars -->
                <div class="rounded mt-1" :class="[light.border]" style="height: 357px; overflow-y: scroll;">
                    <div class="input-group flex-nowrap mb-1" v-for="(bd, bi) in maindata.internet.bars" :key="bi">
                        <div class="btn fw-bold text-start font-italic" :class="[light.text, light.border]" style="width: 30%; font-size: 11px;">
                            {{bd.alias}}
                        </div>
                        <div class="btn fw-bold me-1" :class="[light.text, light.border]" style="width: 10%; font-size: 11px;">
                            {{bd.total}}
                        </div>
                        <div class="input-group flex-nowrap" :style="`width: ${ bd.total * (60 / getMax(maindata.internet.bars, 'total'))}%`">
                            <div class="bg-success text-white" style="height: 100%; align-content: center; cursor: default;" :style="`width: ${(bd.connected / bd.total) * 100}%`" :title="`ISP: ${bd.alias}\nConnected: ${bd.connected}\nDisconnected: ${bd.disconnected}\nTotal: ${bd.total}`">
                                <span class="fw-bold" style="font-size: 12px;">{{bd.connected > 20 ? bd.connected:null}}</span>
                            </div>
                            <div class="bg-danger text-white" style="height: 100%; align-content: center; cursor: default;" :style="`width: ${(bd.disconnected / bd.total) * 100}%`" :title="`ISP: ${bd.alias}\nConnected: ${bd.connected}\nDisconnected: ${bd.disconnected}\nTotal: ${bd.total}`">
                                <span class="fw-bold" style="font-size: 12px;">{{bd.disconnected > 20  ? bd.disconnected:null}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <!-- Disconnected Services -->
                <div class="input-group flex-nowrap">
                    <div class="text-start fw-light fs-6 mb-1" :class="[light.text]" style="letter-spacing: 3px; width: 30%;">
                        <i class="fa-solid fa-circle-xmark text-danger"></i>
                        Disconnected Services
                    </div>
                    <input type="text" v-model="internet_disconnected_word" class="btn rounded" :class="[light.text,light.border,light.back]" placeholder="Search site..." style="height: 30px; width: 30%; cursor: text;">
                </div>
                <div class="mt-2">
                    <div class="input-group flex-nowrap" :class="[light.border]" style="overflow-y:scroll;">
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Interface name.">
                            <i class="fa-solid fa-ethernet"></i>
                        </div>
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Pop name.">
                            <i class="fa-solid fa-object-group"></i>
                        </div>
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Provider">
                            <i class="fa-solid fa-location-dot"></i>
                        </div>
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Tunnel Remote IP.">
                            <i class="fa-solid fa-network-wired"></i>
                        </div>
                        <div class="btn text-start" :class="[light.text,light.header]" style="width: 20%; font-size: 15px;" title="Provider">
                            <i class="fa-solid fa-gears"></i>
                        </div>
                    </div>
                </div>
                <div style="overflow-y:scroll; height: 350px;" :class="[light.border]">
                    <div class="input-group flex-nowrap" :class="[light.border_bottom]" v-for="(ds, dsi) in internet_disconnected" :key="dsi">
                        <div class="btn fw-bold text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Interface name.">
                            {{ds.interface}}
                        </div>
                        <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 12px;" title="Pop name.">
                            {{ds.popname}}
                        </div>
                        <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 13px;" title="Provider">
                            {{ds.popname}}
                        </div>
                        <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 13px;" title="Tunnel Remote IP.">
                            {{ds.tunnel}}
                        </div>
                        <div class="btn text-start" :class="[light.text]" style="width: 20%; font-size: 13px;" title="Provider">
                            {{ds.provider}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
// @ is an alias to /src
import SiteMap from '@/components/apps-components/integrations/customers/sigma/deps/SiteMap.vue'

import axios from "axios";

export default {
  name: 'Level1',
  props:{
    site: String,  
    light: Object,
    mapkey: String
  },
  components: {
    SiteMap
  },
  data(){
    return {
        source: "cato-level-1",
        loading: false,
        maindata :{
            summary:{
                sites:{
                    connected: 0,
                    disabled: 0,
                    disconnected: 0,
                    total: 0
                },
                devices:{
                    connected: 0,
                    disconnected: 0,
                    total: 0
                }
            },
            connected: [],
            disconnected:[],
            internet:{
                summary:{
                    connected: 0,
                    disconnected: 0,
                    total: 0
                },
                bars:[],
                disconnected:[]
            }
        },
        // Filters
        connected_searchfield: 'sitename',
        connected_searchword: null,
        disconnected_searchfield: 'sitename',
        disconnected_searchword: null,
        internet_disconnected_word: null,
        timestamp: null
    }
  },
    methods:{
        getMaindata(){
            this.loading = true
            console.log('Getting main data...')
            const params = { source: `${this.source}` }
            const dest = this.site + '/integrations/cato/data'
            axios
                .get(dest, {params})
                .then(rx => {
                    // Code
                    this.maindata = rx.data.response.data
                    this.timestamp = rx.data.response.timestamp
                    this.loading = false
                    this.stopLoading()
                })
                .catch(error => {
                    //this.processErrorMessage(error)
                    this.loading = false
                    this.stopLoading()
                }); 
        },
        stopLoading(){
            this.$emit('clear-loading-lv1', this.timestamp);
        },
        titlelize(_string){
        return _string.toLowerCase()
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join('-');
        },
        renderMap(){
            // Code
        },
        getMax(array_of_objects, key){
            return Math.max(...array_of_objects.map(item => item[key]));
        },
        getSum(array_of_objects, key){
            let sum = array_of_objects.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[key];
                }, 0);
            return sum.toFixed(2)
        }
  },
    computed: {
        connected_elements() {
            // Connection filter
            let connected = this.maindata.disconnected.filter(element => (element.operational && element.connectivity));
            // Word filter.
            if (this.connected_searchword != null){
                connected = connected.filter(element => element[this.connected_searchfield].toLowerCase().includes(this.connected_searchword.toLowerCase()))
            }
            return connected
        },
        disconnected_elements() {
            let disconnected = this.maindata.disconnected.filter(element => (!element.operational || !element.connectivity));
            // Word filter.
            if (this.disconnected_searchword != null){
                disconnected = disconnected.filter(element => element[this.disconnected_searchfield].toLowerCase().includes(this.disconnected_searchword.toLowerCase()))
            }
            return disconnected
        },
        internet_disconnected(){
            let internet_disconnected = this.maindata.internet.disconnected
            if (this.internet_disconnected_word != null){
                internet_disconnected = internet_disconnected.filter(element => element.popname.toLowerCase().includes(this.internet_disconnected_word.toLowerCase()))
            }
            return internet_disconnected
        }
    },
    created: function(){
        // Code
        //this.getMaindata()
    },
    mounted: function(){
        // Code
    }
  

}
</script>

<style scoped>

    .cato-main-color{
        color: rgb(67,139, 108);
    }

    .back-darker{
        background-color: rgb(49, 49, 49);
    }

    .border-bottom-light-grey{
        border-bottom: solid rgb(32, 32, 32) 1px
    }

    .bg-bar{
        background-color: rgb(241,175,61);
    }

</style>